import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { COMPANY } from "@/lib/constants";

export const ConsultationCTA = ({ title = "Ready to start care at home?", subtitle }) => (
  <section className="bg-[hsl(var(--secondary))] text-white relative overflow-hidden grain" data-testid="consultation-cta">
    <div className="absolute -top-24 -right-24 w-80 h-80 rounded-full bg-primary/30 blur-3xl pointer-events-none" />
    <div className="container-page py-14 lg:py-16 relative text-center">
      <h2 className="font-heading font-bold text-3xl md:text-4xl">{title}</h2>
      <p className="text-lg text-white/75 mt-3 max-w-2xl mx-auto">
        {subtitle || "One quick call to our friendly team starts your care. We handle all the arrangements — including insurance verification at no cost."}
      </p>
      <div className="flex flex-col sm:flex-row justify-center gap-4 mt-8">
        <a href={COMPANY.phoneHref} data-testid="cta-call-btn"
          className="inline-flex items-center justify-center gap-2 rounded-full bg-accent hover:bg-accent/90 text-accent-foreground h-15 px-8 py-4 text-lg font-bold transition-colors">
          <Phone className="w-5 h-5" /> Call {COMPANY.phone}
        </a>
        <Link to="/contact" data-testid="cta-contact-btn"
          className="inline-flex items-center justify-center gap-2 rounded-full border-2 border-white/30 hover:bg-white hover:text-secondary h-15 px-8 py-4 text-lg font-bold transition-colors">
          Request a Free Consultation <ArrowRight className="w-5 h-5" />
        </Link>
      </div>
    </div>
  </section>
);
